import localforage from 'localforage'
import axios from 'axios'

export const codeSearch = {
    state: {
        codeSearchQuery: '',
        codeSearchResults: null,
        codeSearchStatus: 'idle', // idle | scanning | searching | offline | noResults | error
        codeSearchError: null,
        isOffline: !navigator.onLine
    },
    mutations: {
        SET_CODE_SEARCH_QUERY(state, query) {
            state.codeSearchQuery = query
        },
        SET_CODE_SEARCH_RESULTS(state, results) {
            state.codeSearchResults = results
        },
        SET_CODE_SEARCH_STATUS(state, status) {
            state.codeSearchStatus = status
        },
        SET_CODE_SEARCH_ERROR(state, error) {
            state.codeSearchError = error
        },
        SET_OFFLINE_STATUS(state, isOffline) {
            state.isOffline = isOffline
        }
    },
    actions: {
        setCodeSearchQuery({ commit }, query) {
            commit('SET_CODE_SEARCH_QUERY', query)
            if (query && query.trim() !== '') {
                commit('SET_CODE_SEARCH_STATUS', 'idle')
            }
        },
        setOfflineStatus({ commit }, isOffline) {
            commit('SET_OFFLINE_STATUS', isOffline)
        },
        searchByCode({ commit, dispatch }, code) {
            commit('SET_CODE_SEARCH_QUERY', code)

            if (!code || code.trim() === '') {
                commit('SET_CODE_SEARCH_RESULTS', null)
                commit('SET_CODE_SEARCH_STATUS', 'idle')
                return
            }

            // Offline mode — filter locally
            if (!navigator.onLine) {
                commit('SET_OFFLINE_STATUS', true)
                dispatch('filterDeliveriesLocally', code)
                return
            }

            commit('SET_CODE_SEARCH_STATUS', 'searching')
            commit('SET_CODE_SEARCH_ERROR', null)

            return localforage.getItem('authUser').then((headers) => {
                return axios.get(process.env.VUE_APP_API + 'deliveries', {
                    params: { contact_search: code },
                    headers: JSON.parse(headers)
                })
                .then((response) => {
                    var results = response.data.data
                    if (results && results.length > 0) {
                        commit('SET_CODE_SEARCH_RESULTS', Object.freeze(results))
                        commit('SET_CODE_SEARCH_STATUS', 'idle')
                        // Cache results for offline use
                        localforage.setItem('codeSearchCache_' + code, results)
                    } else {
                        commit('SET_CODE_SEARCH_RESULTS', null)
                        commit('SET_CODE_SEARCH_STATUS', 'noResults')
                    }
                })
                .catch((error) => {
                    console.error('Code search error:', error)
                    // On network error, try offline filtering
                    if (!navigator.onLine || (error.response === undefined)) {
                        commit('SET_OFFLINE_STATUS', true)
                        dispatch('filterDeliveriesLocally', code)
                    } else {
                        commit('SET_CODE_SEARCH_STATUS', 'error')
                        commit('SET_CODE_SEARCH_ERROR', 'Błąd wyszukiwania. Spróbuj ponownie.')
                    }
                })
            })
        },
        searchByContact({ commit, dispatch }, contactQuery) {
            commit('SET_CODE_SEARCH_QUERY', contactQuery)

            if (!contactQuery || contactQuery.trim() === '') {
                commit('SET_CODE_SEARCH_RESULTS', null)
                commit('SET_CODE_SEARCH_STATUS', 'idle')
                return
            }

            // Offline mode — filter locally
            if (!navigator.onLine) {
                commit('SET_OFFLINE_STATUS', true)
                dispatch('filterDeliveriesLocally', contactQuery)
                return
            }

            commit('SET_CODE_SEARCH_STATUS', 'searching')
            commit('SET_CODE_SEARCH_ERROR', null)

            return localforage.getItem('authUser').then((headers) => {
                return axios.get(process.env.VUE_APP_API + 'deliveries', {
                    params: { contact_search: contactQuery },
                    headers: JSON.parse(headers)
                })
                .then((response) => {
                    var results = response.data.data
                    if (results && results.length > 0) {
                        commit('SET_CODE_SEARCH_RESULTS', Object.freeze(results))
                        commit('SET_CODE_SEARCH_STATUS', 'idle')
                    } else {
                        commit('SET_CODE_SEARCH_RESULTS', null)
                        commit('SET_CODE_SEARCH_STATUS', 'noResults')
                    }
                })
                .catch((error) => {
                    console.error('Contact search error:', error)
                    if (!navigator.onLine || (error.response === undefined)) {
                        commit('SET_OFFLINE_STATUS', true)
                        dispatch('filterDeliveriesLocally', contactQuery)
                    } else {
                        commit('SET_CODE_SEARCH_STATUS', 'error')
                        commit('SET_CODE_SEARCH_ERROR', 'Błąd wyszukiwania. Spróbuj ponownie.')
                    }
                })
            })
        },
        filterDeliveriesLocally({ commit, rootState }, query) {
            commit('SET_CODE_SEARCH_STATUS', 'offline')
            var searchTxt = window.unaccent(query.toLowerCase())

            var allDeliveries = rootState.deliveries.deliveries
            if (!allDeliveries) {
                // Try from localforage
                localforage.getItem('deliveries').then(function (cached) {
                    if (cached) {
                        var filtered = filterDeliveryList(cached, searchTxt)
                        if (filtered.length > 0) {
                            commit('SET_CODE_SEARCH_RESULTS', Object.freeze(filtered))
                        } else {
                            commit('SET_CODE_SEARCH_RESULTS', null)
                            commit('SET_CODE_SEARCH_STATUS', 'noResults')
                        }
                    } else {
                        commit('SET_CODE_SEARCH_RESULTS', null)
                        commit('SET_CODE_SEARCH_STATUS', 'noResults')
                    }
                })
                return
            }

            var filtered = filterDeliveryList(allDeliveries, searchTxt)
            if (filtered.length > 0) {
                commit('SET_CODE_SEARCH_RESULTS', Object.freeze(filtered))
            } else {
                commit('SET_CODE_SEARCH_RESULTS', null)
                commit('SET_CODE_SEARCH_STATUS', 'noResults')
            }
        },
        clearCodeSearch({ commit }) {
            commit('SET_CODE_SEARCH_QUERY', '')
            commit('SET_CODE_SEARCH_RESULTS', null)
            commit('SET_CODE_SEARCH_STATUS', 'idle')
            commit('SET_CODE_SEARCH_ERROR', null)
        }
    },
    getters: {
        getCodeSearchQuery: function (state) { return state.codeSearchQuery },
        getCodeSearchResults: function (state) { return state.codeSearchResults },
        getCodeSearchStatus: function (state) { return state.codeSearchStatus },
        getCodeSearchError: function (state) { return state.codeSearchError },
        getIsOffline: function (state) { return state.isOffline }
    }
}

function filterDeliveryList(deliveries, searchTxt) {
    return deliveries.filter(function (delivery) {
        // Search by code field
        if (delivery.code && delivery.code.toLowerCase().includes(searchTxt)) {
            return true
        }
        // Search by EAN / barcode
        if (delivery.ean && delivery.ean.toLowerCase().includes(searchTxt)) {
            return true
        }
        // Search by contact person name
        if (delivery.business_cards) {
            var contactName = ((delivery.business_cards.first_name || '') + ' ' + (delivery.business_cards.last_name || '')).toLowerCase()
            if (window.unaccent(contactName).includes(searchTxt)) {
                return true
            }
        }
        // Search by client name
        if (delivery.client_details) {
            if (delivery.client_details.unaccent_name && delivery.client_details.unaccent_name.toLowerCase().includes(searchTxt)) {
                return true
            }
            if (delivery.client_details.name && window.unaccent(delivery.client_details.name.toLowerCase()).includes(searchTxt)) {
                return true
            }
        }
        // Search by BOK contact
        if (delivery.bok) {
            var bokName = ((delivery.bok.name || '') + ' ' + (delivery.bok.surname || '')).toLowerCase()
            if (window.unaccent(bokName).includes(searchTxt)) {
                return true
            }
        }
        return false
    })
}
